export default class LeadPageCardType {
  static get Community() {
    return this.getInstance('community');
  }

  static get Plan() {
    return this.getInstance('plan');
  }

  static get Spec() {
    return this.getInstance('spec');
  }

  static get MasterPlanCommunity() {
    return this.getInstance('masterPlanCommunity');
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new LeadPageCardType(key);
    }

    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return this.name;
  }
}

Object.defineProperty(LeadPageCardType, 'instances', { value: {} });
